import { ICON_PATHS } from "src/apps/components/icon/IconSVGPaths";
import styled from "styled-components";
import { Icon, ICON_SIZES } from "src/apps/components/icon/Icon";
import { Button } from "src/apps/components/button/Button";
import { useTranslations } from "src/apps/hooks/useTranslations";
import { ACCEPTED_UPLOAD_FILE_TYPES } from "src/apps/providers/uploaders/constants";
import { IdentityVerificationDocumentSides } from "src/contexts/identityVerification/domain/IdentityVerificationDocumentSides";
import { TEST_IDS } from "src/apps/config/testIds";

const UPLOAD_DOCUMENT_DOCS_AI = "documentation_area.uploader_box.upload_document";

interface IDVMobileIdleOrderBoxUploaderProps {
  side: IdentityVerificationDocumentSides;
  onFileDrop: (e: React.ChangeEvent<HTMLInputElement>) => Promise<void>;
}

export const IDVMobileIdleOrderBoxUploader = ({
  side,
  onFileDrop,
}: IDVMobileIdleOrderBoxUploaderProps) => {
  const { t } = useTranslations();

  return (
    <MobileUploader>
      <UploadInput
        id="files"
        data-testid={TEST_IDS.identityVerification.fileInput(side)}
        onChange={onFileDrop}
        accept={ACCEPTED_UPLOAD_FILE_TYPES}
        multiple={false}
        type="file"
      />
      <ButtonContainer>
        <Button
          variant="outline"
          onClick={() => {}}
          text={t(UPLOAD_DOCUMENT_DOCS_AI)}
          leftIcon={
            <Icon
              path={ICON_PATHS.ARROW_UP_FROM_BRACKET}
              color={"currentColor"}
              size={ICON_SIZES.s14}
            />
          }
        />
      </ButtonContainer>
    </MobileUploader>
  );
};

const ButtonContainer = styled.div`
  width: 100%;
`;

const ColumnGap16 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const MobileUploader = styled(ColumnGap16)`
  position: relative;
  flex: 1;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
`;

const UploadInput = styled.input.attrs({ type: "file" })`
  flex: 1;
  position: absolute;
  opacity: 0;
  cursor: pointer;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
`;
